;
define("notifications_order_promocodes.tpl", function(){});

